const SideBannerData = {
    company: {
        title: "Company",
        links: [
            {
                sub: "회사개요",
                link: "/company/info",
            },
            {
                sub: "CEO 인사말",
                link: "/company/ceo",
            },
            {
                sub: "연혁",
                link: "/company/history",
            },
            {
                sub: "인증현황",
                link: "/company/certList",
            },
            {
                sub: "CI 소개",
                link: "/company/ci",
            },
            {
                sub: "오시는 길",
                link: "/company/way",
            },
        ],
    },
    portfolio: {
        title: "PORTFOLIO",
        links: [
            {
                sub: "주요납품 소개",
                link: "/portfolio/partner/1",
            },
            {
                sub: "납품 갤러리",
                link: "/portfolio/delivery/1",
            },
        ],
    },
    rfid_nfc: {
        title: "RFID / NFC",
        links: [
            {
                sub: "RFID/NFC 개요",
                link: "/rfid-nfc/info",
            },
            {
                sub: "CHIP 종류",
                link: "/rfid-nfc/chip",
            },
        ],
    },
    solution: {
        title: "SOLUTION",
        links: [
            {
                sub: "근태관리솔루션",
                link: "/solution/attend",
            },
            {
                sub: "등하원관리솔루션",
                link: "/solution/school",
            },
            {
                sub: "NFC 인코딩솔루션",
                link: "/solution/nfc",
            },
            {
                sub: "RFID R/W 솔루션",
                link: "/solution/rfid",
            },
            {
                sub: "900Mhz TAG 인코딩 솔루션",
                link: "/solution/tag",
            },
            {
                sub: "RFID/NFC 카드인쇄",
                link: "/solution/cardprint",
            },               
        ],
    },
    support: {
        title: "SUPPORT",
        links: [
            {
                sub: "공지사항",
                link: "/support/notice/1",
            },
            {
                sub: "온라인 문의",
                link: "/support/inquiry/1",
            },
            {
                sub: "결제 하기",
                link: "/support/buy",
            },
            {
                sub: "원격 지원",
                link: "/support/remote",
            },
            {
                sub: "자료실",
                link: "/support/reference",
            },
        ],
    },
};

export default SideBannerData;